import Request from './request'

const Client  = {
  getClients(callback) {
    Request.get('client/list').then(callback).catch(this.bad_answer)
  },
  getClientInfo(client_id, callback) {
    Request.get('client/info/' + client_id).then(callback).catch(this.bad_answer)
  },
  editClientInfo(client_id, params, callback) {
    Request.post('client/update/' + client_id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  saveClientInfo(params, callback) {
    Request.post('client/create', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}

export default Client
